import dayjs from "dayjs";
import * as Handlebars from "handlebars";
import { formatAmount } from "./utils";
Handlebars.registerHelper('ifEquals', function (v1, v2, options) {
    if (v1 === v2) {
        return options.fn(this);
    }
    return options.inverse(this);
});
Handlebars.registerHelper('json', (context) => { return JSON.stringify(context); });
Handlebars.registerHelper('decimal2', (value, options) => {
    return formatAmount(value, 2);
});
Handlebars.registerHelper('decimal', (value, options) => {
    return formatAmount(value);
});
Handlebars.registerHelper('multiply', (value, otherValue) => {
    return value * otherValue;
});
Handlebars.registerHelper('select', (selected, options) => {
    return options.fn(this).replace(new RegExp(' value=\"' + selected + '\"'), '$& selected="selected"');
});
Handlebars.registerHelper('upper', (value) => {
    return value.toUpperCase();
});
Handlebars.registerHelper('date', (isoformatDate, format) => {
    let date = dayjs(isoformatDate);
    return date.format("DD/MM/YYYY HH:mm");
});
function fun_list(childrens, iterator = 0) {
    if (!childrens) {
        childrens = [];
    }
    let result = '';
    let parent = '';
    if (childrens.length > 0) {
        parent = 'hlist-parent';
    }
    let wsubs = false;
    let wsubs_text = '';
    let lsubs = '';
    childrens.forEach((val, index) => {
        let SUBS = fun_list(val['childrens'], iterator = iterator + 1);
        lsubs = '';
        if (SUBS) {
            lsubs = 'lsubs';
            wsubs = true;
        }
        let url = val['url'];
        let title = val['title'];
        result += `<li class="hlist-item hlist-item-${index} ${lsubs}"><a href="/listings/${url}/"> ${title}</a>${SUBS}</li>`;
    });
    if (wsubs) {
        wsubs_text = 'wsubs';
    }
    else {
        wsubs_text = 'nsubs';
    }
    if (result) {
        result = `<ul class="hlist hlist-${iterator} ${parent} ${wsubs_text}">${result}</ul>`;
    }
    return result;
}
Handlebars.registerHelper('lista', (childrens, iterator = 0) => {
    if (typeof iterator !== 'number') {
        iterator = 0;
    }
    return fun_list(childrens, iterator);
});
export class HandlebarsRender {
    constructor(templateSelector, containerSelector) {
        this.containerSelector = containerSelector;
        this._render = null;
        this.templateSelector = templateSelector;
        const el = document.querySelector(templateSelector);
        if (!el) {
            console.log('Invalid template selector');
            return;
        }
        const template = el.innerHTML;
        this._template_src = template;
        this._render = Handlebars.compile(template);
    }
    render(data, replace, callback) {
        const container = document.querySelector(this.containerSelector);
        if (!container) {
            console.debug(`No section ${this.containerSelector}`);
            return;
        }
        if (!this._render) {
            console.debug(`No section ${this.containerSelector} (render)`);
            return;
        }
        let html = '';
        try {
            if (data instanceof Array) {
                var index = 0;
                for (let obj of data) {
                    obj['_index'] = index;
                    html += this._render(obj);
                    index += 1;
                }
            }
            else {
                if (this._render) {
                    html = this._render(data);
                }
            }
        }
        catch (e) {
            console.error(`Error section ${this.containerSelector} (render)`, this._template_src);
        }
        if (!replace) {
            container.insertAdjacentHTML('beforeend', html);
        }
        else {
            container.innerHTML = html;
        }
        callback === null || callback === void 0 ? void 0 : callback.call(container);
    }
}
